/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

export const buildArray = (length: number, defaultValue = 0) => {
  return new Array(length).fill(defaultValue);
};

export const iterateTimes = <T>(
  count: number,
  callback: (index: number) => T
) => {
  return buildArray(count).map((_, index) => callback(index));
};
